import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import usePersistStoreData from "../../Components/Hooks/usePersistStoreData";
import TableContainerSearch2 from "../../Components/Common/TableContainerSearch2";
import TableContainer1 from "../../Components/Common/TableContainer1";
import axios from "axios";
import exportToPDF from "../../Components/Common/exportToPDF";
import TableContainerDateRangeFilter3 from "../../Components/Common/TableContainerDateRangeFilter3";
import exportToExcel from "../../Components/Common/exportToExcel";
import { useDispatch } from "react-redux";
import { shareEmailReportThunk } from "../../slices/thunks";
import { showToast } from "../../Components/ToastNotification";
import CommonLoading from "../../Components/Common/CommonLoading";
import { adjustToWorkingDay } from "../../Components/Common/WorkingDateRange";

const FnOTrade = () => {
  // document.title = "Dashboard | B.N. Rathi";

  const { userData } = usePersistStoreData();
  // console.log("userData", userData);
  const dispatch = useDispatch();
  const token = userData?.token;
  const [dateRange, setDateRange] = useState([]);
  const [exchangeFilter, setExchangeFilter] = useState("");
  const [rightColumn, setRightColumn] = useState(true);

  const today = new Date();
  let yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  yesterday = adjustToWorkingDay(yesterday, "end");

  const [selectedDate, setSelectedDate] = useState(today);
  const toggleRightColumn = () => {
    setRightColumn(!rightColumn);
  };
  const [isTopPageDropdown, setTopPageDropdown] = useState(false);
  const toggleDropdown = () => {
    setTopPageDropdown(!isTopPageDropdown);
  };

  // instrument, expiry, strike_price, option_type, trade_type, trade_date, trade_time, market_rate, debit, credit

  const columns = useMemo(
    () => [
      { id: "instrument", Header: "INSTRUMENT", accessorKey: "instrument" },
      { id: "expiry_date", Header: "Expiry", accessorKey: "expiry_date" },
      {
        id: "strike_price",
        Header: "Strike Price (₹)",
        accessorKey: "strike_price",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      { id: "option_type", Header: "Opt. Type", accessorKey: "option_type" },
      { id: "trade_type", Header: "Trade Type", accessorKey: "trade_type" },
      {
        id: "trade_date",
        Header: "Trade Date",
        accessorKey: "trade_date",

        
      },
      {
        id: "trade_time",
        Header: "Trade Time",
        accessorKey: "trade_time",

        
      },
      {
        id: "trade_qty",
        Header: "Trade Qty.",
        accessorKey: "trade_qty",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "market_rate",
        Header: "Mkt. rate (₹)",
        accessorKey: "market_rate",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
     
     
     
      {
        id: "debit",
        Header: "Purchase Value (₹)",
        accessorKey: "debit",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      
      {
        id: "credit",
        Header: "Sale Value (₹)",
        accessorKey: "credit",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
     
     
     
    ],
    []
  );

  const [data, setData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [expense, setExpense] = useState(null);
  const [loading, setLoading] = useState(false);
  const [exchange, setEchange] = useState("");
  const [error, setError] = useState(null);

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handleShareEmail = async () => {
    
    const body = {
      report_type: "trade-confirmations",
     
      "additional_data[segment]" : "FO",
      "additional_data[start_date]": formatDate(selectedDate),
      "additional_data[end_date]": formatDate(selectedDate),
      // "additional_data[exchange]" : exchangeFilter ,
    };

    try {
      const response = await dispatch(
        shareEmailReportThunk({ body, token })
      ).unwrap();

      showToast("Report sent on your email successfully", "success");
    } catch (error) {
      console.error("Error submitting request:", error);
      showToast(
        error?.message || "Something went wrong, please try again",
        "error"
      );
    }
  };

  useEffect(() => {
    const fetchHoldings = async () => {
      setLoading(true);
      setError(null);
      
  
      const startDate = new Date(yesterday);
      startDate.setDate(yesterday.getDate() - 6);
      try {
        const response = await axios.get("trade-confirmations", {
          params: { segment: "FO",
          start_date: formatDate(today),
          end_date: formatDate(today),
          exchange:''
         }, // Pass holdingType as query param
          headers: {
            Authorization: `Bearer ${userData?.token}`, // Add Authorization header
            "Content-Type": "application/json",
          },
        });
        setExpense(response?.data?.expenses)
        setSummary(response?.data?.summary);
        // console.log("here", response, response.data?.summary);
        setData(response.data?.items); // Update state with fetched data
        // setTimeout(() => {
        setLoading(false);
        // }, 2000);
      } catch (err) {
        console.error("Error fetching holdings:", err);
        // setSummary(null)
        setError(err);
        setLoading(false);
      } finally {
        // setSummary(null)
        setLoading(false);
      }
    };

    fetchHoldings();
  }, []); // Runs when holdingType or token changes

  const handleDateRangeChange = async (values) => {
    // console.log("values",values)
    // setLoading(true);
    setError(null);
    // const holdingType = 1;
    try {
      const response = await axios.get("trade-confirmations", {
        params: {
          segment: "FO",
          start_date: formatDate(selectedDate),
          end_date: formatDate(selectedDate),
          exchange:values?.exchangeFilter
        }, // Pass holdingType as query param
        headers: {
          Authorization: `Bearer ${userData?.token}`, // Add Authorization header
          "Content-Type": "application/json",
        },
      });

      // console.log("here", response);
      setEchange(values?.exchangeFilter);
      setExpense(response?.data?.expenses)
      setSummary(response.data?.summary);
      setData(response.data?.items); // Update state with fetched data
      // setTimeout(() => {
      values.setTableLoading(false);
      // }, 2000);
    } catch (err) {
      console.error("Error fetching holdings:", err);
      // setSummary(null)
      setError(err);
      values.setTableLoading(false);
      setEchange('');
    } finally {
      values.setTableLoading(false);
      // setSummary(null)
    }
  };

  const tableHeaders = columns.map((col) => col.Header.replace(/₹/g, "Rs"));
  const tableBody = data.map((row) =>
  columns.map((col) => {
    // if (col.Header === "Trade Date & Time") {
    //   return `${row?.trade_date ?? ""} ${row?.trade_time ?? ""}`.trim();
    // }
    return row[col.accessorKey]
      ? typeof row[col.accessorKey] === "string"
        ? row[col.accessorKey]
        : row[col.accessorKey].toLocaleString("en-IN")
      : 0;
  })
);
 // Define which columns to sum
 const sumColumns = ["debit", "credit"];
 // Example API response for totals
 const apiTotals = {
   debit: summary?.total_debit ?? 0, // Replace with actual API data
   credit: summary?.total_credit ?? 0,
 };

 // Insert API totals only for "debit" and "credit"
 const totals = columns.map((col, index) => {
   if (index === 0) return "TOTAL"; // First column will have "Total"

   return sumColumns.includes(col.accessorKey)
     ? apiTotals[col.accessorKey]?.toLocaleString("en-IN") || 0 // Use API total, default to 0 if missing
     : ""; // Leave other columns empty
 });

 // Add totals row to the ta
 tableBody.push(totals);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {loading ? (
            <div
              className="centerContent h-100 w-100"
              style={{ minHeight: "80vh" }}
            >
             <CommonLoading />
            </div>
          ) : (
          
            <Card className="mb-6">
              <CardHeader>
                <div className="m-0 p-0 d-flex align-items-center justify-content-between">
                  <h3 className="m-0">Trade Confirmation - F&O</h3>
                  <Dropdown
                    isOpen={isTopPageDropdown}
                    toggle={toggleDropdown}
                    className={`card-header-dropdown ${data?.length === 0 ? 'disabled-dropdown_export' : ''}`}
                  >
                    <DropdownToggle
                      tag="a"
                      className="text-reset dropdown-btn"
                      role="button"
                      color="success"
                    >
                      <Button type="button" color="success">
                        Export<i className="ms-1 bx bx-caret-down"></i>
                      </Button>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                      <DropdownItem
                        onClick={() =>
                          exportToPDF(
                            "Trade Confirmation - F&O",
                            userData,
                            ``,
                            `As on Date: ${summary?.as_on_date}`,
                            tableHeaders,
                            tableBody
                          )
                        }
                      >
                        Export as PDF
                      </DropdownItem>
                      <DropdownItem
                      onClick={() =>
                        exportToExcel(
                          "Trade Confirmation - F&O",
                          userData,
                          exchange ? `${exchange}` : "Combined",
                          `As on Date: ${summary?.as_on_date}`,
                          tableHeaders,
                          tableBody,
                          "",
                          [],
                          []
                        )
                      }
                      >Export Excel</DropdownItem>
                      <DropdownItem
                      onClick={handleShareEmail}
                      >Share on Email</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </CardHeader>
              <CardBody>
                <TableContainerDateRangeFilter3
                  footer={true}
                  summary={summary}
                  columns={columns}
                  data={data}
                  onDateRangeChange={handleDateRangeChange}
                  type={'FO'}
                  dateRange = {dateRange}
                  setDateRange = {setDateRange}
                  exchangeFilter = {exchangeFilter}
                  setExchangeFilter = {setExchangeFilter}
                  selectedDate = {selectedDate}
                  setSelectedDate = {setSelectedDate}
                  yesterday      = {yesterday}
                />
              </CardBody>
            </Card>
            
          
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FnOTrade;
